import React, { useState, useEffect } from 'react'

import { Layout, PageHeader, Button, message } from 'antd'

import HeaderNavigation from '../../components/HeaderNavigation'
import ChooseProjectModal from '../../components/project/ChooseProjectModal'
import ActModal from '../../components/ActModal'
import ActTable from '../../components/ActTable'
import usePagination from '../../components/hooks/usePagination'
import { getActs } from '../../services/acts'

import './style.css'

const { Content } = Layout

const Acts = () => {
  const [isLoading, setIsLoading] = useState(false)

  const [filter, setFilter] = useState({})
  const [pageTotal, setPageTotal] = useState(0)
  const [tablePagination, page, pageSize, setPage] = usePagination(pageTotal)

  const [showProjectDialog, setShowProjectDialog] = useState(false)
  const [showActDialog, setShowActDialog] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null)

  const [acts, setActs] = useState([])
  const [selectedAct, setSelectedAct] = useState(null)

  const requestActs = () => {
    const pagination = { page, pageSize }
    setIsLoading(true)
    getActs(filter, pagination)
      .then(({ data }) => {
        setActs(data?.results)
      })
      .catch((error) => {
        message.error('Ошибка загрузки актов')
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => requestActs(), [filter, page, pageSize])

  const onProjectDialogCancel = () => setShowProjectDialog(false)

  const onProjectSubmit = (project) => {
    setSelectedProject(project)
    setShowProjectDialog(false)
    setShowActDialog(true)
  }

  const onAction = (record) => {
    setSelectedAct(record)
    setShowActDialog(true)
  }

  const onFilterFormSubmit = (values) => setFilter({ projects: values?.projects || [] })

  const onFilterFormClear = () => setFilter({})

  return (
    <Layout>
      <HeaderNavigation activeKey="5" />
      <Content className="site-layout" style={{ padding: '85px 50px', minHeight: '100vh' }}>
        <PageHeader
          ghost={false}
          title="Акты"
          extra={[
            <Button key="1" type="primary" onClick={() => setShowProjectDialog(true)}>
              Создать новый акт
            </Button>,
          ]}
        />
        <ActTable
          acts={acts}
          isLoading={isLoading}
          tablePagination={tablePagination}
          onAction={onAction}
          onFilterFormSubmit={onFilterFormSubmit}
          onFilterFormClear={onFilterFormClear}
        />
        <ChooseProjectModal
          showModal={showProjectDialog}
          onFinish={onProjectSubmit}
          onChancel={onProjectDialogCancel}
        />
        <ActModal
          showModal={showActDialog}
          project={selectedProject}
          act={selectedAct}
          onClose={() => {
            setShowActDialog(false)
            setSelectedAct(null)
            requestActs()
          }}
          onSuccess={() => {
            setShowActDialog(false)
            requestActs()
          }}
        />
      </Content>
    </Layout>
  )
}

export default Acts
